<template>
  <footer class="footer-area">
    <div class="container">
      <div class="row ON_footer_items_area">
        <div class="col-lg-6 col-md-8 col-sm-8">
          <div class="ON_footer_item_single ON_footer_image_padding">
            <img src="../assets/logo.png" width="150" height="50" alt="" />
            <p>
              Every search, every click and every question is logged. Your
              information is being measured, stored and analysed to sell you
              things with laser-like precision. Your searches are being used to
              crete a bubble around you with "similar interests" and similar
              thigs, similar people. You don't get to chose, you don't get to
              pick what to see what to do and finally, what to think. No more.
              We are the 21st century news, the happenings of today. We don't
              feed you opinions, we don't feed you narative. We will give you
              impartial, non compromising truth. It is for you to judge and for
              you to form your own opinion. We are here to give you the tools.
            </p>
          </div>
        </div>
        <div class="col-lg-6 col-md-8 col-sm-8">
          <div class="ON_footer_item_single">
            <div class="ON_ON_footer_title">
              <h3>Quick Links</h3>
            </div>
            <div class="row">
              <div class="col-6">
                <ul class="list">
                  <li>
                    <router-link to="/about" v-scroll-to="{ el: '#topOfPage' }"
                      >About Us</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/disclamer"
                      v-scroll-to="{ el: '#topOfPage' }"
                      >Disclamer</router-link
                    >
                  </li>
                  <li><a href="#" @click="show">Feedback</a></li>
                </ul>
              </div>
              <div class="col-6">
                <ul class="list">
                  <li>
                    <router-link to="/help" v-scroll-to="{ el: '#topOfPage' }"
                      >Help Center</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/legal-notes"
                      v-scroll-to="{ el: '#topOfPage' }"
                      >Privacy Policy</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/terms-of-use"
                      v-scroll-to="{ el: '#topOfPage' }"
                      >Terms of Use</router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row footer-bottom d-flex justify-content-between align-items-center"
      ></div>
    </div>
    <cookie-law theme="dark-lime"
      ><div slot="message">
        We use cookies to deliver exceptional user experience, and no we are not
        sharing! For more info
        <router-link to="/legal-notes" v-scroll-to="{ el: '#topOfPage' }">
          Click here</router-link
        >
      </div></cookie-law
    >
    <div
      class="row footer-bottom d-flex justify-content-between align-items-center"
    >
      <div class="col-lg-12">
        <div class="f_boder"></div>
      </div>
      <p class="col-lg-8 col-md-8 footer-text m-0">
        Copyright Objective News &copy;2020, All rights reserved | V 1.0
      </p>
    </div>
    <modal name="feedbackForm">
      <div class="container">
        <hr />
        <form @submit.prevent="formPost" class="row ON_contact_form">
          <div class="col-md-6">
            <div class="form-group">
              <input
                required="required"
                type="text"
                class="form-control"
                placeholder="Enter your name"
                v-model="feedbackItem.name"
              />
            </div>
            <div class="form-group">
              <input
                required="required"
                type="email"
                class="form-control"
                placeholder="Enter email address"
                v-model="feedbackItem.email"
              />
            </div>
            <div class="form-group">
              <input
                required="required"
                type="text"
                class="form-control"
                placeholder="Enter Subject"
                v-model="feedbackItem.subject"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <textarea
                required="required"
                class="form-control"
                rows="1"
                placeholder="Enter Message"
                v-model="feedbackItem.message"
              ></textarea>
            </div>
          </div>
          <div
            class="col-md-12 text-right"
            v-if="
              feedbackItem.email !== '' &&
                feedbackItem.name !== '' &&
                feedbackItem.subject !== '' &&
                feedbackItem.message !== ''
            "
          >
            <button class="btn ON_submit_button" @click="formPost">
              Send Message
            </button>
          </div>
        </form>
        <hr />
      </div>
    </modal>
  </footer>
</template>

<script>
import CookieLaw from "vue-cookie-law";
import db from "@/fb";

export default {
  components: { CookieLaw },
  data() {
    return {
      feedbackItem: {
        email: "",
        name: "",
        subject: "",
        message: "",
        source: "feedback"
      }
    };
  },
  methods: {
    show() {
      this.$modal.show("feedbackForm");
    },
    hide() {
      this.$modal.hide("feedbackForm");
    },
    formPost() {
      db.collection("feedback")
        .add(this.feedbackItem)
        .then(() => {
          this.hide();
        })
        .catch(function(error) {
          console.error("Error adding document: ", error);
        });
    }
  }
};
</script>
